
class EventProgramListViewController extends BaseTableViewController
{
    static newInstance() : EventProgramListViewController {
        let vc = new EventProgramListViewController("event-program-list-view");
        vc.initWithResource("layout/event_program/EventProgramListView.html");
        return vc;
    }

    private addButton:MUIButton = null;    

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function(){
            this.addEventProgram();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;        
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("EventProgramCell") as EventProgramCell;        

        let item:EventProgram = this.fetchedResultsController.objectAtIndexPath(indexPath);
        cell.item = item;

        cell.selected = item === this.selectedItem ? true : false;

        return cell;
    }
     
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        this.selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath) as EventProgram;
        this.showEventProgramDetailViewController();
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;
    
        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName("EventProgram");            
        fetchRequest.sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey("name", true)];
                
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;
    
        return this._fetchedResultsController;
    }
    
    private addEventProgram(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let eventProgram = MIOEntityDescription.insertNewObjectForEntityForName("EventProgram", ad.managedObjectContext) as EventProgram;
        eventProgram.name = "New eventProgram";
        eventProgram.descriptionInfo = "New eventProgram description";
        ad.managedObjectContext.save();        

        this.selectedItem = eventProgram;

        this.showEventProgramDetailViewController();
    }
    
    private showEventProgramDetailViewController(){
                
        let vc = new EventProgramDetailViewController('event-program-detail-view');
        vc.initWithResource('layout/event_program/EventProgramDetailView.html');           
        vc.eventProgram = this.selectedItem;
        this.splitViewController.showDetailViewController(vc);   
    }
}